const SERVICE_OS_URL = '#open-booking-form';

/**
 * Returns whether a link is a ServiceOS booking link and the appropriate href.
 */
export function getServiceOSLink(originalHref?: string): {
  isServiceOS: boolean;
  href: string;
} {
  if (!originalHref) {
    return { isServiceOS: false, href: '' };
  }

  const isDirectServiceOS = originalHref.startsWith(SERVICE_OS_URL);

  if (isDirectServiceOS) {
    return { isServiceOS: true, href: originalHref };
  }

  return { isServiceOS: false, href: originalHref };
}
